import React from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import { TextInput } from 'components/Common/Inputs/TextInput';
import PoweredBy from 'components/PoweredBy';

const isRequired = value => !value || !value.trim();

const LoginForm = ({
  handleSubmit,
  errorMessage,
  onCloseErrorMessage,
  isFetching,
  isFetchingUserConfig,
  showSSOLogin
}) => (
  <form
    className="login-form"
    onSubmit={ values => handleSubmit(values) }
  >
    <div className="login-logo-container">
      <div className="login-logo" />
      <PoweredBy />
    </div>

    <h1 className="taina-brand">
      T<span className="taina-ai">AI</span>NA Fully Automated Tax Form Validator and Classifier
    </h1>

    <hr />

    <fieldset>
      <div className="form-group">
        <Field
          type="email"
          name="login"
          component={ TextInput }
          className="form-input input-lg"
          placeholder="Your email"
          required
          hideHints
          normalize={ value => value && value.replace(/^[ ]+/g, '') }
          validate={ isRequired }
        />
      </div>
      <div className="form-group">
        <Field
          type="password"
          name="password"
          component={ TextInput }
          className="form-input input-lg"
          placeholder="Your password"
          required
          hideHints
          validate={ isRequired }
        />
      </div>
    </fieldset>

    { errorMessage && <div className="error-wrapper">
      <div className="toast toast-error">
        <button
          type="button"
          className="btn btn-clear float-right"
          onClick={ () => onCloseErrorMessage() }
        />
        { errorMessage.code === 401 && !errorMessage.message && 'Please enter a valid email and password' }
        { ((errorMessage.code !== 401)
          || (errorMessage.code === 401 && errorMessage.message)) && <span>
            Access Denied: { errorMessage.message }
          </span> }
      </div>
    </div> }

    <div className="form-group submit-wrapper">
      <button
        type="submit"
        className={ `btn btn-primary btn-block btn-lg ${ isFetching || isFetchingUserConfig ? 'loading' : '' }` }
      >Sign in</button>
    </div>

    { showSSOLogin && <div className="form-group submit-wrapper">
      <button
        type="button"
        className="btn btn-secondary btn-block btn-lg"
        onClick={ () => { window.location = '/'; } }
      >Sign in with Single Sign-On</button>
    </div> }
  </form>
);

LoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.shape({
    code: PropTypes.number,
    message: PropTypes.string
  }),
  onCloseErrorMessage: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  isFetchingUserConfig: PropTypes.bool,
  showSSOLogin: PropTypes.bool
};

LoginForm.defaultProps = {
  errorMessage: null,
  isFetching: false,
  isFetchingUserConfig: false,
  showSSOLogin: false
};

export default reduxForm({
  form: 'signIn-form'
})(LoginForm);
